type Props = {
  src: string;
  onLoad?: () => void;
  node?: HTMLElement;
  once?: boolean;
  id?: string;
};

export const appendScript = ({ src, onLoad = () => {}, node = document.body, once, id }: Props) => {
  if (!src) return;
  if (once && id && document.getElementById(id)) return;

  const script = document.createElement('script');
  script.src = src;
  script.onload = onLoad;
  script.id = id || '';

  node.appendChild(script);
};
